<div class="fmnts-sort-header__container">
  <span class="fmnts-sort-header__content">
    <ng-content />
  </span>

  @if (_isSorted() || !_isDisabled()) {
    <fa-icon [icon]="iconName" class="fmnts-sort-header__icon" />
  }
</div>
